import type { TaskFileChangeView } from '@/lib/api/generated/model';

/**
 * Where a path a run's summary mentions really is.
 *
 * An agent writes "main.py and README.md" in its summary while it saved them
 * into the task's folder (`tasks/<slug>/output/main.py`, spec 113). Read from
 * the workspace root, those words linked to whatever else had the same name
 * there — another run's leftovers. What the run recorded is the better
 * witness: a mentioned path that matches the tail of exactly one file the run
 * created or changed means that file. Anything else — an exact match, no
 * match, or several equally good ones — stays as written.
 */
export function resolveRunPath(
  path: string,
  runFiles: readonly Pick<TaskFileChangeView, 'path' | 'event_type'>[],
): string {
  const present = runFiles
    .filter((file) => file.event_type !== 'deleted')
    .map((file) => file.path);
  if (present.includes(path)) return path;
  const matches = [
    ...new Set(present.filter((candidate) => candidate.endsWith(`/${path}`))),
  ];
  return matches.length === 1 ? matches[0] : path;
}
